import React from 'react';
import { BarChart3, TrendingUp } from 'lucide-react';

export const AnalyticsPage: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3.5 rounded-xl bg-white dark:bg-[#181b23] border border-neutral-200 dark:border-[#262c39] shadow-xs">
        <div>
          <h1 className="text-base font-bold text-neutral-900 dark:text-neutral-100 flex items-center gap-2">
            <BarChart3 className="w-5 h-5 text-orange-500" />
            Crowd Density & Flow Analytics
          </h1>
          <p className="text-xs text-neutral-500 dark:text-neutral-400">
            Historical footfall analytics, ingress/egress velocities, and predictive bottlenecks
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="p-3.5 rounded-xl bg-white dark:bg-[#181b23] border border-neutral-200 dark:border-[#262c39]">
          <span className="text-xs text-neutral-500 dark:text-neutral-400 font-medium">Net Ingress Flow Rate</span>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-neutral-900 dark:text-neutral-100">42.8</span>
            <span className="text-xs text-neutral-400">persons / min</span>
          </div>
          <span className="text-[11px] text-emerald-500 flex items-center mt-1">
            <TrendingUp className="w-3 h-3 mr-0.5" /> +8% vs weekday average
          </span>
        </div>

        <div className="p-3.5 rounded-xl bg-white dark:bg-[#181b23] border border-neutral-200 dark:border-[#262c39]">
          <span className="text-xs text-neutral-500 dark:text-neutral-400 font-medium">Bottleneck Risk Index</span>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-orange-500">Moderate</span>
            <span className="text-xs text-neutral-400">Level 2</span>
          </div>
          <span className="text-[11px] text-amber-500 flex items-center mt-1">
            Gate 4 Security check delay ~3.2m
          </span>
        </div>

        <div className="p-3.5 rounded-xl bg-white dark:bg-[#181b23] border border-neutral-200 dark:border-[#262c39]">
          <span className="text-xs text-neutral-500 dark:text-neutral-400 font-medium">Daily Cumulative Visitors</span>
          <div className="mt-1 flex items-baseline gap-2">
            <span className="text-2xl font-bold font-mono text-neutral-900 dark:text-neutral-100">18,940</span>
            <span className="text-xs text-neutral-400">total tracked</span>
          </div>
          <span className="text-[11px] text-emerald-500 flex items-center mt-1">
            <TrendingUp className="w-3 h-3 mr-0.5" /> Normal seasonal volume
          </span>
        </div>
      </div>

      {/* Heatmap & Flow Breakdown */}
      <div className="p-4 rounded-xl bg-white dark:bg-[#181b23] border border-neutral-200 dark:border-[#262c39]">
        <h3 className="text-xs font-bold uppercase tracking-wider text-neutral-500 dark:text-neutral-400 mb-3">
          Zone Density Matrix
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[
            { zone: 'Main Concourse', density: '88%', status: 'High', color: 'bg-orange-500' },
            { zone: 'Terminal Gate 1-6', density: '45%', status: 'Normal', color: 'bg-emerald-500' },
            { zone: 'Security Checkpoint', density: '94%', status: 'Surge', color: 'bg-red-500' },
            { zone: 'Baggage Claim North', density: '32%', status: 'Low', color: 'bg-emerald-500' },
          ].map((item, i) => (
            <div key={i} className="p-3 rounded-lg bg-neutral-50 dark:bg-[#1e222c] border border-neutral-200/80 dark:border-[#282e3c]">
              <div className="text-xs font-semibold text-neutral-800 dark:text-neutral-200">{item.zone}</div>
              <div className="text-xl font-bold font-mono text-neutral-900 dark:text-neutral-100 mt-1">{item.density}</div>
              <div className="flex items-center gap-1.5 mt-2">
                <span className={`w-2 h-2 rounded-full ${item.color}`} />
                <span className="text-[10px] text-neutral-400 uppercase font-medium">{item.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
